export default function CollapsedList() {
  const collapsedLists = document.querySelectorAll('.collapsed-list');
  
  if (!collapsedLists) return;

  const collapsedListExpandedClass = 'collapsed-list--is-expanded';
  const collapsedItemHiddenClass = 'collapsed-list__item--is-hidden';
  const expandButtonHtml = '<span class="collapsed-list__expand"></span>' + lfc.translations.expandList;
  const collapseButtonHtml = '<span class="collapsed-list__collapse"></span>' + lfc.translations.collapseList;

  function toggleList(list, button) {
    if (list.classList.contains(collapsedListExpandedClass)) {
      list.classList.remove(collapsedListExpandedClass);
      button.innerHTML = expandButtonHtml;
    } else {
      list.classList.add(collapsedListExpandedClass);
      button.innerHTML = collapseButtonHtml;
    }
  }
  
  collapsedLists.forEach(collapsedList => {
    let collapsedItems = collapsedList.querySelectorAll('li');

    if (!collapsedItems.length) return;

    let collapseButton = document.createElement('button');
  
    collapseButton.className = 'button collapsed-list__button';
    collapseButton.innerHTML = expandButtonHtml;
    collapsedList.after(collapseButton);

    collapseButton.addEventListener('click', () => toggleList(collapsedList, collapseButton));
  
    collapsedItems.forEach((collapseItem, index) => {
      index > 3 && collapseItem.classList.add(collapsedItemHiddenClass);
    });
  });
};
